var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('titles',{attrs:{"titlename":"导入题目","titlecontent":"这里可以看到导入题目一些信息","mbx":_vm.paths}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }